import http from './http'

export const getFileTree = (data)=>{
    return http({
        method:'get',
        url:'/web/file/list',
        params: data
    })
}

export const getFileTreeByIds = (data)=>{
    return http({
        method:'post',
        url:'/web/file/list/byIds',
        data: data
    })
}

export const getDownloadUrl = (data)=>{
    return http({
        method:'post',
        url:'/web/file/getDownloadUrl',
        data: data
    })
}

export const getZipDownloadUrl = (data)=>{
    return http({
        method:'post',
        url:'/web/zip/file/info/getZipDownloadUrl',
        data: data
    })
}

export const getZipInfo = (data)=>{
    return http({
        method:'post',
        url: `/web/zip/file/info/info/${data}`,
    })
}

export const mapMark = (data)=>{
    return http({
        method:'post',
        url:`/web/file/mapMark/${data}`,
    })
}



